import { connect } from 'react-redux'
import { setErrorMessage, notify } from 'actions/account'
import { setModal } from 'actions/account'

const mapStateToProps = () => ({})

const withRedux = connect(
  mapStateToProps,
  { setErrorMessage, setModal, notify }
)

export default withRedux
